export const NotificationVariant = Object.freeze({
    FILLED: "filled",
    OUTLINED: "outlined",
    STANDARD: "standard",
});
